export default __webpack_public_path__ + "scripts/resources/assignments/en/kinetics/k2/species.json";